<template>
  <div class="head_row_calander relative bg--white flex no_mobile">
    <div v-if="showConnectedCalendars" class="calander_select_doc">
      <div style="display:none">{{ title }}</div>
      <select2 v-model="selectedDoctor">
        <option
          :value="doctor.id"
          v-for="(doctor, index) in connectedCalendars"
          :key="index"
        >
          {{ title }} {{ doctor.name }}
        </option>
      </select2>
    </div>

    <div
      class="title title--40 tx--blue2 no-marge no-print"
      v-if="showHeaderTitle"
    >
      {{ getTitle($route.name) }}
    </div>

    <div class="head-alert flex flex--content--center">
      <div
        v-if="
          activeDoctorPolicies &&
            activeDoctorPolicies.length &&
            ($route.name === 'Dashboard' || $route.name === 'surgeries')
        "
        class="bg--error tx--red cursor-p flex flex--content--center"
      >
        <img src="/assets/img/svg/alert.svg" />
        לתשומת ליבך: תום תוקף ביטוח מתקרב.
        <div class="tx--under" @click="openPolicies">
          לפרטים לחצ/י כאן.
        </div>
      </div>

      <div
        v-if="changedAppointments && $route.name === 'Dashboard'"
        class="bg--error tx--red cursor-p flex flex--content--center"
        @click="toPendingApp"
        style="margin-top: 8px;"
      >
        <img src="/assets/img/svg/alert.svg" />
        נמצאו {{ changedAppointments }} תורים שמועדם השתנה.
        <div class="tx--under">
          לצפייה ושליחת sms
        </div>
      </div>
    </div>

    <div v-if="$route.name === 'Dashboard'" class="flex">
      <a href="javascript:void(0);" @click="onSearchBtn" class="head-desk-msg">
        <div class="relative">
          <img src="/assets/img/svg/search.svg" />
        </div>
      </a>
      <router-link to="/messages" class="head-desk-msg">
        <div class="relative">
          <span
            v-show="
              activeUser &&
                activeUser.doctor_messages &&
                activeUser.doctor_messages.length
            "
            class="pathology-dot"
          ></span>
          <img src="/assets/img/svg/sm-mail.svg" />
        </div>
      </router-link>
      <router-link to="/add-block" class="bt_blue" style="margin-left: 10px;">
        יצירת בלוק
        <span class="plus"></span>
      </router-link>
      <router-link to="/app-add" class="bt_blue no-print">
        יצירת תור
        <span class="plus"></span>
      </router-link>
    </div>

    <div class="no-print flex" v-if="$route.name === 'surgeries'">
      <a href="javascript:void(0);" @click="onSearchBtn" class="head-desk-msg">
        <div class="relative">
          <img src="/assets/img/svg/search.svg" />
        </div>
      </a>
      <router-link
        to="/surg-add-block"
        class="bt_blue bg--blue-light bt-surg-add-block"
      >
        הזמנת בלוק ניתוחים
      </router-link>
      <router-link to="/surg-add" class="bt_blue">
        יצירת ניתוח לשיבוץ
        <span class="plus"></span>
      </router-link>
    </div>

    <div v-if="$route.name === 'profile'">
      <router-link
        v-if="!userUpdateRequestExists"
        to="/profile-edit"
        class="bt_blue edit_pen_white"
        style="padding-right: 22px;"
      >
        <PenSvg /> <span>עריכת פרטים</span>
      </router-link>
      <div class="profile-edit-bt flex flex--content--center tx--blue" v-else>
        <img src="assets/img/svg/ic-pen-blue.svg" />

        בקשתך לעריכה בטיפול
      </div>
    </div>
    <div v-if="$route.name === 'profile-edit'" class="head-profile-edit-btns">
      <router-link to="/profile" class="head_cancel">
        ביטול
      </router-link>
      <a
        href="javascript:void(0);"
        @click="$emit('saveProfile')"
        class="bt_blue"
        style="padding-right: 22px;"
      >
        <span v-show="!isLoadingProfile">
          <img
            width="21"
            src="assets/img/svg/saved.svg"
            style="margin-left:6px;"
          />
          <span>שמירה</span>
        </span>
        <vue-loaders-ball-clip-rotate
          v-show="isLoadingProfile"
          color="white"
          scale="0.8"
          style="position: relative;top: 8px;"
        ></vue-loaders-ball-clip-rotate>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import PendingAppointmentsDesktop from "../Popups/PendingAppointmentsDesktop.vue";
import Policies from "@/components/Popups/Policies.vue";
import SearchDesktop from "@/components/Popups/SearchDesktop.vue";
import PenSvg from "@/assets/img/svg/ic-pen.svg";

export default {
  name: "HeaderDesktop",
  components: { PenSvg },
  props: ["userUpdateRequestExists", "isLoadingProfile"],
  data() {
    return {
      title: null,
      selectedDoctor: null,
      pending_appointments: []
    };
  },
  computed: {
    ...mapGetters([
      "activeDoctor",
      "connectedCalendars",
      "isChangeApp",
      "activeDoctorPolicies",
      "activeUser"
    ]),
    changedAppointments() {
      return this.pending_appointments.length;
    },
    showConnectedCalendars() {
      return (
        this.connectedCalendars &&
        this.$route.path !== "/dashboard/calendar" &&
        this.$route.path !== "/dashboard/surgeries" &&
        !this.$route.path.includes("profile")
      );
    },
    showHeaderTitle() {
      return (
        this.$route.path === "/dashboard/calendar" ||
        this.$route.path === "/dashboard/surgeries" ||
        this.$route.path.includes("profile")
      );
    }
  },
  methods: {
    ...mapMutations(["SET_IS_CHANGE_APP"]),
    getTitle(type) {
      switch (type) {
        case "Dashboard":
          return `היומן של`;
        case "clinic":
          return `בלוק מרפאה של`;
        case "calendar":
        case "above":
          return `מבט על`;
        case "surgeries":
          return `חדרי ניתוח`;
        case "list":
          return `רשימת תורים`;
        case "profile":
          return "פרופיל משתמש";
        case "profile-edit":
          return "עריכת פרופיל משתמש";
        default:
          return "";
      }
    },
    toPendingApp() {
      this.$modal.show(PendingAppointmentsDesktop);
    },
    openPolicies() {
      this.$modal.show(Policies);
    },
    onSearchBtn() {
      // Set time out for click outside
      setTimeout(() => {
        this.$modal.show(SearchDesktop, {
          id: "",
          results: [],
          isMenu: false
        });
      }, 100);
    }
  },
  mounted() {
    this.$API.getPendingAppointments(this.activeDoctor.id).then(res => {
      this.pending_appointments = res.message;
    });
  },
  created() {
    this.title = this.getTitle(this.$route.name);
    this.selectedDoctor = this.$store.state.activeDoctor.id;
  },
  watch: {
    $route(to, from) {
      this.title = this.getTitle(to.name);
    },
    selectedDoctor(val) {
      this.$store.dispatch("SET_DOCTOR", val);
    },
    activeDoctor(val) {
      this.selectedDoctor = val.id;
    },
    async isChangeApp(val) {
      if (val) {
        await this.$API
          .getPendingAppointments(this.activeDoctor.id)
          .then(res => {
            this.pending_appointments = res.message;
          });
        this.SET_IS_CHANGE_APP(false);
      }
    }
  }
};
</script>
